(function () {
  var CLOUDINARY_URL = 'https://api.cloudinary.com/v1_1/{cloud}/image/upload';
  var MAX_SIZE = 5 * 1024 * 1024; // 5 MB
  var ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/heic'];

  document.querySelectorAll('[data-comu-upload]').forEach(initUploader);

  function initUploader(root) {
    var cloud = root.dataset.comuUploadCloud;
    var preset = root.dataset.comuUploadPreset;
    var max = parseInt(root.dataset.comuUploadMax, 10) || 3;
    var folder = root.dataset.comuUploadFolder || '';
    if (!cloud || !preset) return;

    var dropZone = root.querySelector('[data-comu-upload-drop]');
    var previews = root.querySelector('[data-comu-upload-previews]');
    var hiddenInput = root.querySelector('[data-comu-upload-urls]');
    var errorEl = root.querySelector('[data-comu-upload-error]');
    var fileInput = root.querySelector('[data-comu-upload-input]');
    var urls = [];
    var uploadUrl = CLOUDINARY_URL.replace('{cloud}', cloud);

    dropZone.addEventListener('click', function () {
      if (urls.length < max) fileInput.click();
    });

    fileInput.addEventListener('change', function () {
      handleFiles(fileInput.files);
      fileInput.value = '';
    });

    dropZone.addEventListener('dragover', function (e) {
      e.preventDefault();
      dropZone.classList.add('is-dragover');
    });

    dropZone.addEventListener('dragleave', function () {
      dropZone.classList.remove('is-dragover');
    });

    dropZone.addEventListener('drop', function (e) {
      e.preventDefault();
      dropZone.classList.remove('is-dragover');
      handleFiles(e.dataTransfer.files);
    });

    function handleFiles(files) {
      clearError();
      for (var i = 0; i < files.length; i++) {
        if (urls.length >= max) {
          showError('Maximum ' + max + ' images allowed.');
          break;
        }
        var file = files[i];
        if (ALLOWED_TYPES.indexOf(file.type) === -1) {
          showError('Only JPG, PNG, GIF, WebP, HEIC allowed.');
          continue;
        }
        if (file.size > MAX_SIZE) {
          showError('File too large (max 5 MB).');
          continue;
        }
        uploadFile(file);
      }
    }

    function uploadFile(file) {
      var thumb = createThumb();
      var reader = new FileReader();
      reader.onload = function (e) {
        thumb.querySelector('img').src = e.target.result;
      };
      reader.readAsDataURL(file);

      var fd = new FormData();
      fd.append('file', file);
      fd.append('upload_preset', preset);
      if (folder) fd.append('folder', folder);

      var xhr = new XMLHttpRequest();
      xhr.open('POST', uploadUrl);
      xhr.onload = function () {
        var loader = thumb.querySelector('[data-loading]');
        if (loader) loader.remove();

        if (xhr.status >= 200 && xhr.status < 300) {
          var res = JSON.parse(xhr.responseText);
          var url = res.secure_url;
          urls.push(url);
          thumb.dataset.url = url;
          syncHidden();
          updateDropState();
        } else {
          thumb.remove();
          if (xhr.status === 420) {
            showError('Image upload is temporarily unavailable. You can still submit the form without images.');
          } else {
            showError('Upload failed. Please try again.');
          }
        }
      };
      xhr.onerror = function () {
        thumb.remove();
        showError('Upload failed. Please check your connection.');
      };
      xhr.send(fd);
    }

    function createThumb() {
      var div = document.createElement('div');
      div.className = 'comu-upload__thumb';
      div.innerHTML =
        '<img src="" alt="">' +
        '<button type="button" class="comu-upload__thumb-remove" aria-label="Remove">&times;</button>' +
        '<div class="comu-upload__thumb-loading" data-loading><div class="comu-upload__spinner"></div></div>';
      div.querySelector('.comu-upload__thumb-remove').addEventListener('click', function () {
        var url = div.dataset.url;
        if (url) {
          var idx = urls.indexOf(url);
          if (idx > -1) urls.splice(idx, 1);
          syncHidden();
        }
        div.remove();
        updateDropState();
      });
      previews.appendChild(div);
      return div;
    }

    function syncHidden() {
      hiddenInput.value = urls.join('\n');
    }

    function updateDropState() {
      dropZone.classList.toggle('is-disabled', urls.length >= max);
    }

    function showError(msg) {
      errorEl.textContent = msg;
    }

    function clearError() {
      errorEl.textContent = '';
    }
  }
})();
